import { StatTableDateTimeColumn } from "./Columns/DateTime/DateTimeColumn";
import { StatTableImageColumn } from "./Columns/Image/ImageColumn";
import { StatTableLinkColumn } from "./Columns/Link/LinkColumn";
import { StatTableNumberColumn } from "./Columns/Number/NumberColumn";
import { StatTableOrgLogoNameColumn } from "./Columns/OrgLogoName/OrgLogoNameColumn";
import { StatTablePercentColumn } from "./Columns/Percent/PercentColumn";
import { StatTablePointsColumn } from "./Columns/Points/PointsColumn";
import { StatTablePositionColumn } from "./Columns/Position/PositionColumn";
import { StatTableTextColumn } from "./Columns/Text/TextColumn";
import { StatTableTimeColumn } from "./Columns/Time/TimeColumn";

export type StatTableColumnBase = {
  header?: string;
  title?: string;
  sortable?: boolean;
  highlight?: boolean;
  frozenWidth?: number;
  border?: number;
  sortDescFirst?: boolean;
};

export type StatTableColumn<T> =
  | StatTableDateTimeColumn<T>
  | StatTableImageColumn<T>
  | StatTableLinkColumn<T>
  | StatTableNumberColumn<T>
  | StatTableOrgLogoNameColumn<T>
  | StatTablePercentColumn<T>
  | StatTablePointsColumn<T>
  | StatTablePositionColumn<T>
  | StatTableTextColumn<T>
  | StatTableTimeColumn<T>;

export interface StatTableCellProps<
  TStats,
  TColumn extends StatTableColumn<TStats>
> {
  stats: TStats;
  column: TColumn;
  columnIdx: number;
  frozenOffset: number | undefined;
}

export function getFrozenColumnOffset(
  columns: StatTableColumnBase[],
  column: StatTableColumnBase,
  index: number
) {
  if (!column.frozenWidth) {
    return undefined;
  }

  const priorColumns = columns.slice(0, index);
  return priorColumns.reduce((a, b) => a + (b.frozenWidth ?? 0), 0);
}
